import type {
  SharedSliceContent,
  SliceItemContent,
} from "@prismicio/types-internal/lib/content"

import { createSliceKey } from "./createSliceKey"

interface CreateSliceArgs {
  sliceId: string
  widget: SliceItemContent["widget"]
  uuid?: string
}

export function createSlice(args: CreateSliceArgs): SliceItemContent {
  const { sliceId, widget, uuid } = args

  return {
    key: createSliceKey({ sliceId, uuid }),
    name: sliceId,
    maybeLabel: undefined,
    widget,
  }
}

interface CreateSharedSliceArgs {
  sliceId: string
  variationId: string
  uuid?: string
  withContent?: SharedSliceContent
}

export function createSharedSlice(
  args: CreateSharedSliceArgs,
): SliceItemContent {
  const { sliceId, variationId, uuid, withContent } = args

  return createSlice({
    sliceId,
    uuid,
    widget: {
      __TYPE__: "SharedSliceContent",
      variation: variationId,
      primary: withContent?.primary ?? {},
      items: withContent?.items ?? [],
    },
  })
}
